// ─── CURSOR ─────────────────────────────────────────────────
const cursor = document.getElementById('cursor');
if (cursor) {
  document.addEventListener('mousemove', e => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
  });
  document.querySelectorAll('a, button, .product-card, .collage-panel').forEach(el => {
    el.addEventListener('mouseenter', () => cursor.classList.add('expanded'));
    el.addEventListener('mouseleave', () => cursor.classList.remove('expanded'));
  });
}

// ─── PARALLAX ───────────────────────────────────────────────
const heroImg = document.getElementById('sn-hero-img');
if (heroImg) {
  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY;
    if (scrolled < window.innerHeight) {
      heroImg.style.transform = `translateY(${scrolled * 0.22}px)`;
    }
  }, { passive: true });
}

// ─── SCROLL REVEAL ──────────────────────────────────────────
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

// Safety net: if the observer never fires (JS error, very tall cards, etc.),
// force everything visible shortly after load so text is never stuck hidden.
window.addEventListener('load', () => {
  setTimeout(() => {
    document.querySelectorAll('.reveal:not(.visible)').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('visible');
    });
  }, 1200);
});

// ─── HAMBURGER MENU ─────────────────────────────────────────
const hamburger = document.getElementById('sn-hamburger');
const mobileMenu = document.getElementById('sn-mobile-menu');

if (hamburger && mobileMenu) {
  const closeMobileMenu = () => {
    mobileMenu.classList.remove('open');
    hamburger.classList.remove('open');
    hamburger.setAttribute('aria-expanded', false);
    document.body.style.overflow = '';
  };

  hamburger.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('open');
    hamburger.classList.toggle('open', isOpen);
    hamburger.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  mobileMenu.querySelectorAll('[data-close]').forEach(link => {
    link.addEventListener('click', closeMobileMenu);
  });
}

// ─── MOBILE CART TOGGLE ─────────────────────────────────────
if (window.matchMedia('(max-width: 768px)').matches) {
  const cartTrigger = document.getElementById('sn-cart-trigger');
  if (cartTrigger) {
    const cartLink = cartTrigger.querySelector('a.nav-icon');
    if (cartLink) {
      cartLink.addEventListener('click', e => {
        e.preventDefault();
        cartTrigger.classList.toggle('cart-open');
      });
      document.addEventListener('click', e => {
        if (!cartTrigger.contains(e.target)) {
          cartTrigger.classList.remove('cart-open');
        }
      });
    }
  }
}

// ─── COLOR SWATCHES ─────────────────────────────────────────
document.querySelectorAll('.product-swatches').forEach(swatchGroup => {
  const card = swatchGroup.closest('.product-card');
  if (!card) return;
  const imgWrap = card.querySelector('.product-img-wrap');
  const tag = card.querySelector('.product-tag');
  const addBtn = card.querySelector('.quick-add-btn:not(.quick-add-btn--unavailable)');
  if (!imgWrap) return;

  const imgMap = {};
  const origImg = imgWrap.querySelector('img');
  const initialActive = swatchGroup.querySelector('.swatch.active');
  const initialColor = initialActive ? initialActive.dataset.color : null;

  swatchGroup.querySelectorAll('.swatch').forEach(swatch => {
    const color = swatch.dataset.color;
    const src = card.dataset[color + 'Img'];
    if (!src) return;

    const el = new Image();
    el.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center top;transition:opacity 0.25s;opacity:0;';
    el.onload = () => {
      if (color === initialColor && origImg) {
        el.style.opacity = '1';
        origImg.style.opacity = '0';
      }
    };
    el.src = src;
    if (el.complete && color === initialColor && origImg) {
      el.style.opacity = '1';
      origImg.style.opacity = '0';
    }
    imgWrap.appendChild(el);
    imgMap[color] = el;
  });

  swatchGroup.querySelectorAll('.swatch').forEach(swatch => {
    swatch.addEventListener('click', e => {
      e.preventDefault();
      const color = swatch.dataset.color;

      Object.entries(imgMap).forEach(([c, el]) => {
        el.style.opacity = c === color ? '1' : '0';
      });
      if (tag) tag.textContent = card.dataset[color + 'Tag'] || '';

      swatchGroup.querySelectorAll('.swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // Update add-to-cart button variant when swatch has data-variant-id
      if (addBtn && swatch.dataset.variantId) {
        addBtn.dataset.variantId = swatch.dataset.variantId;
      }
    });
  });
});

// ─── QUICK ADD TO CART ───────────────────────────────────────
const toast = document.getElementById('sn-cart-toast');
let toastTimer;

function showToast(productName) {
  if (!toast) return;
  toast.innerHTML = `<div class="cart-toast-inner">
    <span class="cart-toast-name">${productName}</span>
    <div class="cart-toast-actions">
      <a href="/cart" class="cart-toast-view">View Cart</a>
      <a href="/checkout" class="cart-toast-checkout">Checkout</a>
    </div>
  </div>`;
  toast.classList.add('visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('visible'), 4000);
}

document.querySelectorAll('.quick-add-btn:not(.quick-add-btn--unavailable)').forEach(btn => {
  btn.addEventListener('click', async e => {
    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const card = btn.closest('.product-card');
    const productName = card ? (card.querySelector('.product-name')?.textContent || 'Item') : 'Item';

    btn.classList.add('quick-add-btn--loading');
    btn.textContent = '...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Cart error');

      btn.classList.remove('quick-add-btn--loading');
      btn.classList.add('quick-add-btn--added');
      btn.textContent = 'Added';
      showToast(productName);

      // Refresh cart badge count
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const badge = document.querySelector('.cart-badge');
          if (badge) {
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
        });

      setTimeout(() => {
        btn.classList.remove('quick-add-btn--added');
        btn.textContent = 'Add to Cart';
      }, 2200);

    } catch {
      btn.classList.remove('quick-add-btn--loading');
      btn.textContent = 'Add to Cart';
    }
  });
});
